export default __webpack_public_path__ + "static/media/info.7384e83d.svg";